const dataShop = [

    {
      id: 1,
      price: 25,
      img: 'oga-bra-brown-Small',
      name: 'Yin Yoga Bra',
      category: 'CLOTHING'
  },

    {
      id: 2,
      price: 30,
      img: 'flowy-pants-Small',
      name: 'Flow Yoga Pants',
      category: 'CLOTHING'
  },
  
  {
    id: 3,
    price: 8,
    img: 'yoga-belt-Small',
    name: 'Elastic Yoga belt',
    category: 'GEAR'
},
{
    id: 4,
    price: 15,
    img: 'yoga-blocks-wood-Small',
    name: 'Wooden Yoga Blocks',
    category: 'GEAR'
},

{
    id: 5,
    price: 20,
    img: 'cotton-joggers-Small',
    name: 'Cotton Yoga Joggers',
    category: 'CLOTHING'
},

{
    id: 6,
    price: 17,
    img: 'candles-two-Small',
    name: 'Aroma Candles Set',
    category: 'MEDITATION'
},

{
    id: 7,
    price: 9,
    img: 'yoga-blocks-plastic-Small',
    name: 'Plastic Yoga Blocks',
    category: 'GEAR'
},

{
    id: 8,
    price: 35,
    img: 'yoga-pants-black-Small',
    name: 'Classic Yoga Pants',
    category: 'CLOTHING'
},


{
    id: 11,
    price: 32,
    img: 'yogawheel-Small',
    name: 'Yoga Wheel',
    category: 'GEAR'
},

{
    id: 12,
    price: 42,
    img: 'longsleeve-top-Small',
    name: 'Long Sleeve Yoga Top',
    category: 'CLOTHING'
},

{
    id: 13,
    price: 35,
    img: 'singing-bowl-large-Small',
    name: 'Tibetab Singing Bowl Large',
    category: 'MEDITATION'
},
{
    id: 14,
    price: 22,
    img: 'yoga-bra-Small',
    name: 'Clasic Yoga Bra',
    category: 'CLOTHING'
},

{
    id: 15,
    price: 39,
    img: 'yoga-pants-Small',
    name: 'Hatha Yoga Pants',
    category: 'CLOTHING'
},

{
    id: 16,
    price: 32,
    img: 'yogabra-biege-Small',
    name: 'Hatha Yoga Bra',
    category: 'CLOTHING'
},
{
    id: 17,
    price: 25,
    img: 'yoga-belt-cotton-Small',
    name: 'Cotton Yoga Belt',
    category: 'GEAR'
},

{
    id: 18,
    price: 51,
    img: 'yogamat-blue-Small',
    name: 'Ocean Yoga Mat',
    category: 'GEAR'
},
{
    id: 19,
    price: 51,
    img: 'yogamat-black-Small',
    name: 'Classic Yoga Mat',
    category: 'GEAR'
},
{
    id: 20,
    price: 51,
    img: 'yoga-mat-green-Small',
    name: 'Forest Yoga Mat',
    category: 'GEAR'
},

{
    id: 21,
    price: 31,
    img: 'sleeveless-top-Small',
    name: 'Sleeveless Yoga Top',
    category: 'CLOTHING'
},

{
    id: 22,
    price: 34,
    img: 'yoga-cycling-shorts-Small',
    name: 'Long Yoga Shorts',
    category: 'CLOTHING'
},
{
    id: 23,
    price: 21,
    img: 'yoga-roller-Small',
    name: 'Yoga Roller',
    category: 'GEAR'
},
{
    id: 24,
    price: 33,
    img: 'candle-and-sticks',
    name: 'Aroma Set',
    category: 'MEDIATAION'
},
{
    id: 25,
    price: 51,
    img: 'yoga-mat-more-Small',
    name: 'Yin Yoga Mat',
    category: 'GEAR'
},
{
    id: 26,
    price: 43,
    img: 'comfy-joggers-Small',
    name: 'Comfy Yoga Joggers',
    category: 'CLOTHING'
},
{
    id: 27,
    price: 38,
    img: 'yogawheel-Small',
    name: 'Yoga Wheel',
    category: 'GEAR'
},
{
    id: 28,
    price: 35,
    img: 'singing-bowl-little-Small',
    name: 'Tibetan Singing Bowl Small',
    category: 'MEDITATION'
},

{
    id: 29,
    price: 12,
    img: 'incenses-Small',
    name: 'Incense',
    category: 'MEDITATION'
},

{
    id: 30,
    price: 36,
    img: 'longsleeve-hoodie-Small',
    name: 'Yoga Hoodie',
    category: 'CLOTHING'
},

{
    id: 31,
    price: 11,
    img: 'candles-one-Small',
    name: 'Scented Candles Set',
    category: 'MEDITATION'
},

{
    id: 32,
    price: 50,
    img: 'gift-card',
    name: '$50 Yoga Shala Gift Card',
    category: 'GIFTCARD'
},

{
    id: 33,
    price: 100,
    img: 'gift-card',
    name: '$100 Yoga Shala  Gift Card',
    category: 'GIFTCARD'
},
{
    id: 34,
    price: 150,
    img: 'gift-card',
    name: '$150 Yoga Shala  Gift Card',
    category: 'GIFTCARD'
},
]

export default dataShop;